/**
 * Checks whether the provided URL is internal (begins with a slash).
 */
export function checkIfInternalUrl(url: string): boolean {
  return url.startsWith('/');
}
